<div class="flexTableViewPort">
  <p-table #ccTable class="crystal-table"
              [value]="records" [loading]="loading"
              styleClass="p-datatable-sm p-datatable-striped"
              [paginator]="true" [totalRecords]="totalRecords"
              [rows]="100"
              currentPageReportTemplate="{totalRecords} {{'page.'+this.transPartKey+'.footer_count' | translate}}"
              [rowsPerPageOptions]="[100,200,500]" [showCurrentPageReport]="true"
              [lazy]="false" [lazyLoadOnInit]="false" (onLazyLoad)="loadRecords($event)"
              [sortField]="fieldName"
              [virtualScroll]="false" [scrollable]="true" [scrollHeight]="scrollHeight"
              virtualScrollItemSize="19"  responsiveLayout="scroll"
              paginatorDropdownAppendTo="body"
  >
    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let columnDef of tableConfig"
            [pSortableColumn]="columnDef.field"
            [style.min-width.px]="columnDef.width ? columnDef.width : null"
            [style.--flex-basis.px]="columnDef.width ? columnDef.width : null"
            [class.flex-basis-important]="!!columnDef.width">
          <div *ngIf="columnDef.field" class="flex justify-content-between align-items-center">
            {{columnDef.label ? columnDef.label : 'page.' + this.transPartKey + '.table.' + columnDef.field | translate}}
            <p-columnFilter type="text"
                            [field]="columnDef.field" display="menu"
                            [matchMode]="'contains'"
                            [showMatchModes]="false"
                            [showOperator]="false"
                            [showAddButton]="false"
                            [showApplyButton]="true"
                            [showClearButton]="true" [hideOnClear]="true"
                            class="p-ml-auto"
            ></p-columnFilter>
            <p-sortIcon [field]="columnDef.field"></p-sortIcon>
          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-record let-rowIndex="rowIndex">
      <tr [ngClass]="fieldEnabled && record[fieldEnabled]?'record-enabled':'record-disabled'">
        <td *ngFor="let columnDef of tableConfig; let columnIndex = index"
            [style.min-width.px]="columnDef.width ? columnDef.width : null"
            [style.--flex-basis.px]="columnDef.width ? columnDef.width : null"
            [class.flex-basis-important]="!!columnDef.width"
            [class]="(tableValueMap['class-' + columnIndex + '_' + rowIndex]?tableValueMap['class-' + columnIndex + '_' + rowIndex]:'')
            +(columnDef.type==='BUTTON'?' button-table':'')"
            >
          <i *ngIf="columnDef.field && columnDef.type!='BUTTON' && columnDef.icon"
             [class]="'icon '+(tableValueMap['icon-' + columnIndex + '_' + rowIndex]?tableValueMap['icon-' + columnIndex + '_' + rowIndex]:'')">{{columnDef.iconValue ? columnDef.iconValue(record) : ''}}</i>
          <span
            *ngIf="columnDef.field && !columnDef.command && !columnDef.format && !columnDef.mapId">
            {{record[columnDef.field]}}
          </span>
          <span *ngIf="columnDef.field && (columnDef.type==='DATETIME'||columnDef.type==='DATE')">
            {{record[columnDef.field]  | date:columnDef.format}}
          </span>
          <span *ngIf="columnDef.field && (columnDef.type==='NUMERIC')">
            {{record[columnDef.field]  | number:columnDef.format ? columnDef.format : '1.0-7'}}
          </span>
          <span *ngIf="columnDef.field && columnDef.mapId"
                [innerHTML]="tableValueMap['mapId-' + columnIndex + '_' + rowIndex]">
          </span>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="paginatorleft">
      <ng-content select="[paginatorleft-content]"></ng-content>
    </ng-template>
    <ng-template pTemplate="paginatorright">
      <ng-content select="[paginatorright-content]"></ng-content>
      <button pButton class="p-button-text p-button-sm" icon="fa fa-file-excel"
              (click)="exportRecords('xlsx')" pTooltip="{{'common.table.export_xls' | translate}}"></button>
      <button pButton class="p-button-text p-button-sm" icon="fa fa-file-csv"
              (click)="exportRecords('csv')" pTooltip="{{'common.table.export_csv' | translate}}"></button>
    </ng-template>
  </p-table>
</div>
